// hooks.ts
import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { RootState } from '../redux/store'; // Adjust the path

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
